// @flow

import React from "react";

const A: ({ href: string, children: React.Element<*> }) => React.Element<*> = ({
  href,
  children
}) => <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>;
export default A;



// WEBPACK FOOTER //
// ./src/A.js